import { useTranslation } from 'next-i18next'
import Image from 'next/future/image'
import { useEffect, useMemo, useState } from 'react'

export default function ShareButtons () {
  const { t } = useTranslation(['plugins', 'common'])
  const [shareUrl, setShareUrl] = useState('')
  const links = useMemo(() => (
    [
      {
        name: 'email',
        url: `mailto:?subject=${t('share.email.text')}&body=${shareUrl}`
      },
      {
        name: 'whatsapp',
        url: `https://api.whatsapp.com/send?text=${shareUrl}`
      },
      {
        name: 'twitter',
        url: `https://twitter.com/intent/tweet?url=${shareUrl}`
      },
      {
        name: 'facebook',
        url: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`
      },
      {
        name: 'linkedin',
        url: `https://www.linkedin.com/sharing/share-offsite/?url=${decodeURIComponent(shareUrl)}`
      }
    ]
  ))

  useEffect(() => {
    setShareUrl(encodeURIComponent(window.location.href))
  }, [])

  const copyToClipboard = () => {
    navigator.clipboard.writeText(decodeURIComponent(shareUrl))
  }

  return (
    <div>
      <button type="button"
        className="btn btn-muted fw-normal"
        data-bs-toggle="modal"
        data-bs-target="#companyShare"
      >
        <svg width="19"
          height="19"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 8C1 8.66304 1.26339 9.29893 1.73223 9.76777C2.20107 10.2366 2.83696 10.5 3.5 10.5C4.16304 10.5 4.79893 10.2366 5.26777 9.76777C5.73661 9.29893 6 8.66304 6 8C6 7.33696 5.73661 6.70107 5.26777 6.23223C4.79893 5.76339 4.16304 5.5 3.5 5.5C2.83696 5.5 2.20107 5.76339 1.73223 6.23223C1.26339 6.70107 1 7.33696 1 8Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M10 4.5C10 5.16304 10.2634 5.79893 10.7322 6.26777C11.2011 6.73661 11.837 7 12.5 7C13.163 7 13.7989 6.73661 14.2678 6.26777C14.7366 5.79893 15 5.16304 15 4.5C15 3.83696 14.7366 3.20107 14.2678 2.73223C13.7989 2.26339 13.163 2 12.5 2C11.837 2 11.2011 2.26339 10.7322 2.73223C10.2634 3.20107 10 3.83696 10 4.5Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M10 12.5C10 13.163 10.2634 13.7989 10.7322 14.2678C11.2011 14.7366 11.837 15 12.5 15C13.163 15 13.7989 14.7366 14.2678 14.2678C14.7366 13.7989 15 13.163 15 12.5C15 11.837 14.7366 11.2011 14.2678 10.7322C13.7989 10.2634 13.163 10 12.5 10C11.837 10 11.2011 10.2634 10.7322 10.7322C10.2634 11.2011 10 11.837 10 12.5Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M5.83008 7.09395L10.1687 5.40662"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M5.73633 9.11865L10.263 11.382"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <span className="ms-2">
          {t('share', { ns: 'common' })}
        </span>
      </button>

      <div
        className="modal fade modal-md"
        id="companyShare"
        tabIndex="-1"
        aria-labelledby="companyShareLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content px-4">
            <div className="modal-header border-0">
              <p
                className="modal-title fs-5 btn-link btn p-0 text-decoration-none fw-bold text-uppercase h1"
                id="companyShareLabel"
              >
                {t('share', { ns: 'common' })}
              </p>
              <button type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body mt-4">
              <div>
                <div className="d-flex justify-content-between">
                  {
                    links.map((link, index) => (
                      <a
                        key={index}
                        href={link.url}
                        className="d-flex flex-column align-items-center text-decoration-none text-muted"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Image
                          src={`/images/icons/${link.name}.svg`}
                          width={50}
                          height={50}
                          alt=""
                        />
                        <span className="mt-1">
                          {t(`share.${link.name}.name`)}
                        </span>
                      </a>
                    ))
                  }
                </div>
                <div className="border d-flex justify-content-around align-items-center p-2 mt-5">
                  {
                    shareUrl && (
                      <span className="text-muted sharebuttons__link">
                        {decodeURIComponent(shareUrl)}
                      </span>
                    )
                  }
                  <button
                    className="btn btn-muted fw-normal"
                    onClick={() => copyToClipboard()}
                  >
                    {t('copy', { ns: 'common' })}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
